var Meters = function () { // eslint-disable-line no-unused-vars
    'use strict';
    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */

    let customerId, buildingId;


    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */

    function getCustomerId() {
        if (customerId) {
            return customerId;
        }

        customerId = $('[name=CustomerId]').val();
        return customerId;
    }

    function getBuildingId() {
        if (buildingId) {
            return buildingId;
        }

        buildingId = $('[name=BuildingId]').val();
        return buildingId;
    }

    function reactivateMeter() {
        $.fdAjax({
            url: $("#REACTIVATE_METER_BUTTON").data("url"),
            callback: function () {
                if (FD.Page && FD.Page.saveMeter) {
                    FD.Page.saveMeter({ responseText: '-1' });
                } else {
                    $("#MeterModal").modal('hide');
                }
            }
        });
    }

    function getRateCodes(utilityProviderId) {
        $.fdAjax({
            url: "/UtilityProviders/" + utilityProviderId + '/RateCode',
            type: "GET",
            callback: function (result) {
                var select = $('#RateCodeId')[0];
                select.options.length = 0;
                select.options.add(new Option("N/A", "", true));
                for (var x = 0; x < result.data.length; x++) {
                    select.options.add(new Option(result.data[x].name, result.data[x].id));
                }
                $(select).prop('disabled', false);
            }
        });
    }

    function getBuildings(customerId) {
        $.fdAjax({
            url: "/Admin/Customers/" + customerId + "/Buildings",
            type: "GET",
            callback: function (result) {
                let select = $('#BuildingId');
                select.children().remove();
                for (var x = 0; x < result.data.length; x++) {
                    let group = result.data[x];
                    let groupElement = $(`<optgroup label="${group.text}"></optgroup>`);
                    groupElement.label = group.text;

                    for (var y = 0; y < group.children.length; y++) {
                        let option = group.children[y];
                        groupElement.append(new Option(option.text, option.value));
                    }
                    select.append(groupElement);
                }
            }
        });
    }

    /* ========================================================================
     *  Public Methods and Variables
     * ========================================================================
    */

    return {
        getRateCodes: getRateCodes,

        getAddMeterModal: function (data) {
            buildingId = data.parentId;
            $('#MeterModal').html(null);
            $.fdAjax({
                url: '/Buildings/' + data.parentid + '/Meters/Add',
                ishtml: true,
                type: 'GET',
                callback: function (result) {
                    if (result.data) {
                        $('#MeterModal').html(result.data).enableControls().modal('show');
                    }
                }
            })
        },

        getAddMeterModalSimple: function (data) {
            $('#MeterModal').html(null);
            var utilityProviderId = this.element.data('utilityproviderid');
            var append = utilityProviderId ? '/' + utilityProviderId + '/' + this.element.data('accountnumber') : '';
            $.fdAjax({
                url: '/Invoices/' + data.parentid + '/Meters/Add' + append,
                ishtml: true,
                type: 'GET',
                callback: function (result) {
                    if (result.data) {
                        $('#MeterModal').html(result.data).enableControls().modal('show');
                    }
                }
            })
        },

        getPrefilledAddMeterModal: function (data) {
            var meterId = data.parentid;
            $('#MeterModal').html(null);
            $.fdAjax({
                url: '/Admin/MissingMeter/Add/' + meterId,
                ishtml: true,
                type: 'GET',
                callback: function (result) {
                    if (result.data) {
                        $('#MeterModal').html(result.data).enableControls().modal('show');
                    }
                }
            })
        },

        getEditMeterModal: function (data) {
            $.fdAjax({
                url: '/Meters/' + data.parentid + '/Edit',
                ishtml: true,
                type: 'GET',
                callback: function (result) {
                    if (result.data) {
                        $('#MeterModal').html(result.data).enableControls().modal('show');
                        $('textarea', '#MeterModal').control_textarea('resize');

                    }
                }
            })
        },

        selectUtilityProvider: function (data) {
            if (data.value && Number(data.value) > 0) {
                $('#AccountNumber').prop('disabled', false);
                if ($('#RateCodeId').length) {
                    getRateCodes(Number(data.value));
                }
            }
        },

        selectCustomer: function (data) {
            $('#BuildingId').prop('disabled', false);
            getBuildings(data.value);
        },

        buildAccountNumberAjax: function () {
            const url = '/Commons/Autocomplete/AccountNumbers';
            return {
                url: url,
                dataType: "json",
                data: function (data) {
                    return {
                        customerId: getCustomerId(),
                        utilityProviderId: $('#UtilityProviderId').val(),
                        term: data.term,
                        appendSelect: true
                    };
                },
                results: function (data) {
                    return {
                        results: data
                    };
                }
            };
        },

        buildSummaryAccountNumberAjax: function () {
            const url = '/Commons/Autocomplete/SummaryAccountNumbers';
            return {
                url: url,
                dataType: "json",
                data: function (data) {
                    return {
                        customerId: getCustomerId(),
                        utilityProviderId: $('#UtilityProviderId').val(),
                        term: data.term,
                        appendSelect: true
                    };
                },
                results: function (data) {
                    return {
                        results: data
                    };
                }
            };
        },

        buildMeterUtilityProviderAjax: function () {
            return {
                url: "/Commons/Autocomplete/UtilityProviders",
                data: function (params) {
                    var query = {
                        term: params.term,
                        allowCreation: false
                    };
                    return query;
                }
            };
        },

        selectedMetric: function (data) {
            $.fdAjax({
                url: "/Commons/Autocomplete/metric-units/" + data.value + "?utilityProviderId=" + $('#UtilityProviderId').val(),
                callback: function (result) {
                    $('[name$=UnitId]').empty().select2({
                        data: result.data.results
                    }).trigger('change');

                    let list = result.data.results.map(x => ({ Id: x.id, Name: x.text }));
                    list.unshift({ Id: "", Name: "N/A", Selected: true});
                    $('select[name$=UndefinedUnitReplacementId]').control_select('replaceOptions', list).trigger('change');
                    $("input[name$=ActivityId]").attr('placeholder', result.data.defaultActivityId)
                }
            });
            $("[data-show-metricid]").addClass("d-none");
            $("[data-show-metricid=" + data.value + "]").removeClass('d-none');
        },

        buildUnitsAjax: function (parentId) {
            var options = child.getBuildingOptions();
            var utilityProviderId = $('#UtilityProviderId').val();
            var url = options.unitsAutocompleteRoute + "/" +
                parentId +
                "?utilityproviderid=" +
                utilityProviderId;

            return {
                url: url
            };
        },

        selectBuilding: function (data) {
            buildingId = data.value;
            $("#sitesControl").toggleClass("d-none", Number(buildingId) > 0);
        },

        deleteMeter: function () {
            $.fdAjax({
                url: $("#DELETE_METER_BUTTON").data("url") + '&inactiveReason=' + $("input[name=InactiveReason]").val(),
                callback: function () {
                    if (FD.Page && FD.Page.saveMeter) {
                        FD.Page.saveMeter({ responseText: '-1' });
                    } else {
                        $("#MeterModal").modal('hide');
                    }
                }
            });
        },

        reactivateMeter: function () {
            return reactivateMeter();
        },

        reactivateMeterWithoutReadings: function () {
            let url = $("#REACTIVATE_METER_BUTTON").data("url");
            $("#REACTIVATE_METER_BUTTON").data("url", url + "&restoreReadings=false");
            return reactivateMeter()
        },
    };
}();